import React from "react";
import "../../styleDotmatrix.css";
import { useSelector } from "react-redux";
import Receipts from "Components/Print/dot-invoice-receipt";
import { Grid } from "@mui/material";
import { width } from "@mui/system";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import BillHeader from "Components/Print/billHeaderDot";
import BillFooter from "Components/Print/BillFooterDot";


const Print = React.forwardRef((props, ref) => {

  const { invoiceCode, date } = useSelector((state) => state.lastInsertInvoice);
  // const printedDate = date ? new Date(date) : new Date();
  const today = new Date().toISOString().split("T")[0];
  const { returnData } = props;
  const {customer,stockHistories} = returnData;
  //const discount = parseFloat(returnedDiscount);


  //Stock History Level
  const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };

  //Invoice Level Calculations


  // const returnedTotal = returnData ? returnData
  //   .map((total) => total.totalAmount)
  //   .reduce((prev, curr) => prev + curr, 0) : ""

  return (

    <div className="printArea" ref={ref}>
      <>
      <div className="bill-page-header">
      
       <BillHeader /> 
     </div>
        <Receipts
        // date={date}
        // title={`INVOICE ${props.code && "RE-Printed"} - ${data.code ? data.code : props.invoiceCode
        //   }`

        // }
        >


          <table className="print-table-pos" style={{ marginTop: 20 }}>

            <div align="center"><strong>SALES RETURN WITHOT BILL {returnData?.code}</strong></div>
            <Grid container>
              <Grid item xs={5}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        {customer?.code}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        To: {customer?.firstName}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        {returnData.customer ? customer.customerAddresses
                          .map((row) => (row.address))
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {customer ? customer.customerAddresses
                          .map((row) => (row.city))
                          : ""}
                      </td>
                    </tr>

                    <tr>
                      <td >
                        {customer ? customer.customerAddresses
                          .map((row) => (row.phone1 + " / " + row.phone2))
                          : ""}

                      </td>
                    </tr>
                    <tr>
                      <td>
                        {today}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>


            </Grid>
            
            </table>

          <table className="print-table-pos" style={{ marginTop: 10 }}>
            <div style={{ borderTop: "1px solid #24242450" }}></div>
            <table className="print-table-pos" style={{ marginRight: 100 }}>

              <thead>
              <tr
                  style={{
                    borderTop: "1px solid #24242450",
                    borderBottom: "1px solid #24242450",
                  }}>
                  <th width="10">#</th>
               
                  <th align="left"  width="420" >
                    <strong>{COLUMNS_NAME.DESCRIPTION}</strong>
                  </th>
                
                  <th align="center" width="90">
                    <strong>{COLUMNS_NAME.QUANTITY}</strong>
                  </th>
                  <th align="right" width="90">
                    <strong>{COLUMNS_NAME.UNIT_PRICE}</strong>
                  </th>
                  <th align="right" width="80">
                    <strong>{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</strong>
                  </th>
                  <th align="right" width="90">
                    <strong>{COLUMNS_NAME.DISCOUNT_AMOUNT}</strong>
                  </th>
                  <th align="right" width="100">
                    <strong>{COLUMNS_NAME.AMOUNT} </strong></th>
                </tr>
              </thead>

              <tbody>

              {stockHistories.map((row, index) => (
                 <tr style={{ borderBottom: "1px solid #24242450"}}>
                 <td align="left">{index + 1}. </td>
               
                 <td style={{ wordBreak: "break-word" }}>
                   {row.name ? row.name : row.itemMaster.name + " - " + row.reference}
                 </td>
                 <td align="center">{parseInt(row.quantity)}</td>
                 <td align="right">{currency((row.invoiceAmount >0) ? row.invoiceAmount :row.costPrice)}</td>
                 <td align="right">{currency(row.discountPercentage)}%</td>
                 <td align="right">{currency(row.discountAmount)}</td>
                 <td align="right">
                   {currency(
                     handleLineTotal(
                      row.quantity,
                      row.invoiceAmount > 0
                      ? row.invoiceAmount
                      : row.retailPrice,
                      row.discountPercentage,
                      row.discountAmount
                     )
                   )}
                 </td>
               </tr>
                ))}

                <tr>

                  <td align="right" style={{ marginTop: 5 }} colSpan={6}>
                    <strong>{COLUMNS_NAME.LAST_TOTAL}</strong>
                  </td>

                  <td align="right" colSpan={2} >
                    <strong>{currency(returnData.totalAmount)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </table>



          {/*  Printed with Biz X */}
          <div style={{ borderTop: "1px solid #24242450" }}></div>

          <div className="row" style={{ marginTop: 50 }}>
            <div className="col-4">
              <div
                style={{
                  borderTop: "1px dashed #24242450",
                  textAlign: "center",
                }}
              >
                {COLUMNS_NAME.PREPAIRED_BY}
              </div>
            </div>


            <div className="col-4">
              <div
                style={{
                  borderTop: "1px dashed #24242450",
                  textAlign: "center",
                }}
              >
                {COLUMNS_NAME.CH4ECKED_BY}
              </div>
            </div>

            <div className="col-">
              <div
                style={{
                  borderTop: "1px dashed #24242450",
                  textAlign: "center",
                }}
              >
                Customer Acceptance
              </div>
            </div>
          </div>

          <div className="col-12">
            <div
              style={{
                textAlign: "center",
              }}
            >
              {TitumDetails.SOLUTION_BY} | {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}

            </div></div>


        </Receipts>
        <div className="page-footer">
           <BillFooter/> 
      </div>
      </>
    </div >

  );
});

export default Print;